import {
  Autocomplete,
  FormControl,
  FormLabel,
  Typography,
  Grid,
  Paper,
  TextField,
  Button,
  Box,
  InputAdornment,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import axios from 'axios';
import { toast } from 'react-toastify';

import { useResponsiveStyles } from '../../utils/responsiveStyles';
import Key from '../../clientVariables.json';

const AddDetailsForm = ({ cancelHandler, stepHandler }) => {
  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    role: '',
    contactNumber: '',
    country: '',
    state: '',
    city: '',
    zipcode: '',
    companyName: '',
    companyUrl: '',
    description: '',
    category: '',
    address: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [zipcodes, setZipcodes] = useState([]);
  const [categories, setCategories] = useState([]);
  const styles = useResponsiveStyles();

  useEffect(() => {
    getStates();
    getCategories();

  }, []);

  useEffect(() => {
    if (formData.state && formData.state !== '') {
      console.log('state id', formData.state);
      getCities(formData.state.id);
    }
  }, [formData.state]);

  useEffect(() => {
    if (formData.city && formData.city !== '') {
      console.log('state id', formData.city);
      getZipCodes(formData.city.id);
    }
  }, [formData.city]);

  useEffect(() => {
    let errorKey = null;

    Object.entries(formErrors).forEach(([key, value]) => {
      // console.log(`${key}@ ${value}`);
      errorKey = key;
    });

    if (errorKey) {
      const errors = validateForm();
      setFormErrors(errors);
    }
  }, [formData]);

  //   const handleChange = (field, value) => {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [field]: value,
  //     }));

  //   };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleChange = (field, value) => {
    if (field === 'contactNumber') {
      const cleanedValue = value.replace(/\D/g, ''); // Remove non-numeric characters
      const formattedValue = formatPhoneNumber(cleanedValue);
      setFormData((prevData) => ({
        ...prevData,
        [field]: formattedValue,
      }));

      const phoneNumberPattern = /^\(\d{3}\) \d{3}-\d{4}$/;
      if (!phoneNumberPattern.test(formattedValue)) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          contactNumber: 'Invalid phone number format. Expected format: (XXX) XXX-XXXX',
        }));
      } else {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          contactNumber: '',
        }));
      }
    } 
    // else if (field === 'email') {
    //   const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   setFormData((prevData) => ({
    //     ...prevData,
    //     [field]: value,
    //   }));
    //   if (!emailPattern.test(value)) {
    //     setFormErrors((prevErrors) => ({
    //       ...prevErrors,
    //       email: 'Invalid email format',
    //     }));
    //   } else {
    //     setFormErrors((prevErrors) => ({
    //       ...prevErrors,
    //       email: '',
    //     }));
    //   }
    // } 
    else {
      setFormData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    }
  };

  const onTextEditorchanged = (value) => {
    // console.log(value);
    setFormData((prevData) => ({
      ...prevData,
      description: value,
    }));
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      console.log('formData', formData);
      try {
        const response = await axios.post(`${Key.domain}/customer/add`, {
          email: formData.email,
          comp_url: formData.companyUrl,
          full_name: formData.fullname,
          mobile: formData.contactNumber,
          countryid: 233,
          stateid: formData.state?.id,
          cityid: formData.city?.id,
          zipcode: formData.zipcode.zipcode,
          role: formData.role,
          comp_name: formData.companyName,
          category: formData.category?.id,
          description: formData.description,
          address: formData.address,
        });
        if (response.status === 200) {
          console.log('customer add ', response.data);
          // response.data.data.company_id
          // response.data.data.message
          // response.data.data.user_id
          stepHandler(response.data.data, formData);
          toast.success("Customer Added", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } catch (error) {
        console.error(error);
        console.log(error.response.data.error);
        toast.error(error.response.data.error, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
      }
    } else {
      const firstErrorField = Object.keys(errors)[0];
      document.getElementById(firstErrorField)?.focus();
    }
  };
  const validateForm = () => {
    const errors = {};
    const phoneNumberPattern = /^\(\d{3}\) \d{3}-\d{4}$/;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const personalEmailDomains = ['gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com', 'icloud.com'];

    const isBusinessEmail = (email) => {
      const domain = email.split('@')[1];
      return !personalEmailDomains.includes(domain);
    };

    if (!formData.fullname?.trim()) {
      errors.fullname = 'Full Name is required';
    }

    if (!formData.email?.trim()) {
      errors.email = 'Email is required';
    } else if (!emailPattern.test(formData.email)) {
      errors.email = 'Invalid email format';
    } else if (!isBusinessEmail(formData.email)) {
      errors.email = 'Personal emails are not allowed';
    }
    // if (!formData.email?.trim()) {
    //   errors.email = 'Email is required';
    // } else if (!emailPattern.test(formData.email)) {
    //   errors.email = 'Invalid email format';
    // }

    if (!formData.role?.trim()) {
      errors.role = 'Role is required';
    }

    if (!formData.contactNumber.match(phoneNumberPattern)) {
      errors.contactNumber = 'Invalid phone number format. Expected format: (XXX) XXX-XXXX';
    }
    if (!formData.companyName?.trim()) {
        errors.companyName = 'Company Name is required';
      }

    if (!formData.state?.name?.trim()) {
      errors.state = 'State is required';
    }

    if (!formData.city?.cityName?.trim()) {
      errors.city = 'City is required';
    }

    // if (!formData.zipcode.length > 0 && formData.workType === "onsite") {
    //   errors.zipcode = "Zipcode is required";
    // }

    return errors;
  };

  //   const validateForm = () => {
  //     const errors = {};
  //     const phoneNumberPattern = /^\(\d{3}\) \d{3}-\d{4}$/;
  //     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  //     if (!formData.fullname?.trim()) {
  //       errors.fullname = 'Full Name is required';
  //     } else if (!formData.email?.trim()) {
  //       errors.email = 'Email is required';
  //     } else if (!formData.role?.trim()) {
  //       errors.role = 'Role is required';
  //     } else if (!formData.contactNumber.match(phoneNumberPattern)) {
  //       errors.contactNumber = 'Invalid phone number format. Expected format: (XXX) XXX-XXXX';
  //     }
  //     else if (!formData.state?.name?.trim()) {
  //       errors.state = 'State is required';
  //     } else if (!formData.city.cityName?.trim()) {
  //       errors.city = 'City is required';
  //     }
  //     // if (!formData.zipcode.length > 0 && formData.workType === "onsite") {
  //     //   errors.zipcode = "Zipcode is required";
  //     // }

  //     return errors;
  //   };

  const getStates = () => {
    fetch(`${Key.domain}/common/get_states_by_countryid`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        country_id: 233,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setStateList(data.data);
      })
      .catch((error) => {
        console.error('Error fetching states:', error);
      });
  };

  const getCities = (id) => {
    fetch(`${Key.domain}/common/get_cities_by_stateid`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        state_id: id,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setCityList(data.data);
      })
      .catch((error) => {
        console.error('Error fetching states:', error);
      });
  };

  const getZipCodes = (id) => {
    fetch(`${Key.domain_jnp}/commonAPIs/get_zipcodes_By_cityId`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        city_id: id,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setZipcodes(data.data);
      })
      .catch((error) => {
        console.error('Error fetching states:', error);
      });
  };
  const getCategories = () => {
    axios
      .get(`${Key.domain}/common/get_all_categories`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      })
      .then((resdata) => {
        console.log(resdata.data.data);
        setCategories(resdata.data.data);
      });
  };
  const formatPhoneNumber = (value) => {
    if (!value) return value;

    const cleaned = value.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return value;
  };

  return (
    <Grid container spacing={0} sx={{ bgcolor: '#F2F4FA' }}>
      <Grid item xs={1.5} />
      <Grid item xs={9}>
        <Paper sx={{ padding: '20px' }}>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Full Name</FormLabel>
                <TextField
                  placeholder="Full Name"
                  size="small"
                  value={formData.fullname}
                  onChange={(e) => handleChange('fullname', e.target.value)}
                  error={formErrors.fullname}
                  helperText={formErrors.fullname}
                  id="fullname"
                  autoComplete="off"
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Email</FormLabel>
                <TextField
                  placeholder="Email"
                  size="small"
                  value={formData.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  error={!!formErrors.email}
                  helperText={formErrors.email}
                  id="email"
                  autoComplete="off"
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Role</FormLabel>
                <TextField
                  placeholder="Role"
                  size="small"
                  value={formData.role}
                  onChange={(e) => handleChange('role', e.target.value)}
                  error={formErrors.role}
                  helperText={formErrors.role}
                  id="role"
                  autoComplete="off"
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Contact Number</FormLabel>
                <TextField
                  placeholder="(XXX) XXX-XXXX"
                  size="small"
                  value={formData.contactNumber}
                  onChange={(e) => handleChange('contactNumber', e.target.value)}
                  error={Boolean(formErrors.contactNumber)}
                  helperText={formErrors.contactNumber}
                  id="contactNumber"
                  autoComplete="off"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">+1</InputAdornment>,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Category</FormLabel>
                <Autocomplete
                  size="small"
                  disablePortal
                  fullWidth
                  options={categories}
                  getOptionLabel={(option) => option.category_title}
                  value={formData.category !== '' ? formData.category : null}
                  onChange={(event, newValue) => handleChange('category', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="Category" />}
                  error={formErrors.category}
                  helperText={formErrors.category}
                  id="category"
                />
                {formErrors.category && (
                  <Typography color="error" variant="caption">
                    {formErrors.category}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Company Name</FormLabel>
                <TextField
                  placeholder="Company Name"
                  size="small"
                  value={formData.companyName}
                  onChange={(e) => handleChange('companyName', e.target.value)}
                  error={formErrors.companyName}
                  helperText={formErrors.companyName}
                  id="companyName"
                  autoComplete="off"
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Company URL</FormLabel>
                <TextField
                  placeholder="Company URL"
                  size="small"
                  value={formData.companyUrl}
                  onChange={(e) => handleChange('companyUrl', e.target.value)}
                  error={formErrors.companyUrl}
                  helperText={formErrors.companyUrl}
                  id="companyUrl"
                  autoComplete="off"
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Address</FormLabel>
                <TextField
                  placeholder="Address"
                  size="small"
                  value={formData.address}
                  onChange={(e) => handleChange('address', e.target.value)}
                  error={formErrors.address}
                  helperText={formErrors.address}
                  id="address"
                  autoComplete="off"
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>State</FormLabel>
                <Autocomplete
                  size="small"
                  disablePortal
                  fullWidth
                  options={stateList}
                  getOptionLabel={(option) => option.name}
                  value={formData.state !== '' ? formData.state : null}
                  onChange={(event, newValue) => handleChange('state', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="State" />}
                  error={formErrors.state}
                  helperText={formErrors.state}
                  id="state"
                  disabled={formData && formData.workType === 'remote'}
                />
                {formErrors.state && (
                  <Typography color="error" variant="caption">
                    {formErrors.state}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>City</FormLabel>
                <Autocomplete
                  size="small"
                  disablePortal
                  fullWidth
                  options={cityList}
                  getOptionLabel={(option) => option.cityName}
                  value={formData.city !== '' ? formData.city : null}
                  onChange={(event, newValue) => handleChange('city', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="City" />}
                  error={formErrors.city}
                  helperText={formErrors.city}
                  id="city"
                  disabled={formData && formData.workType === 'remote'}
                />
                {formErrors.city && (
                  <Typography color="error" variant="caption">
                    {formErrors.city}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            {/* <Grid item xs={4}>
                <FormControl variant="standard" fullWidth>
                <FormLabel>Zipcode</FormLabel>
                {
                   zipcodes?.length > 0 ?     
                   <Autocomplete
                   size="small"
                   disablePortal
                   fullWidth
                   options={zipcodes}
                   getOptionLabel={(option) => option.zipcode}
                   value={formData.zipcode !== '' ? formData.zipcode : null}
                   onChange={(event, newValue) => handleChange('zipcode', newValue)}
                   renderInput={(params) => <TextField {...params} placeholder="Zipcode" />}
                   error={formErrors.zipcode}
                   helperText={formErrors.zipcode}
                   id="zipcode"
                 /> : 
                 <TextField
                  placeholder="Zipcode"
                  size="small"
                  value={formData.zipcode}
                  onChange={(event, newValue) => handleChange('zipcode', newValue)}
                  error={Boolean(formErrors.zipcode)}
                  helperText={formErrors.zipcode}
                  id="zipcode"
                />
                }
              
                {formErrors.zipcode && (
                  <Typography color="error" variant="caption">
                    {formErrors.zipcode}
                  </Typography>
                )}
              </FormControl> 
            </Grid> */}
            <Grid item xs={4}>
              {
                zipcodes?.length > 0 ?
                  <FormControl variant="standard" fullWidth>
                    <FormLabel>Zipcode</FormLabel>
                    <Autocomplete
                      size="small"
                      disablePortal
                      fullWidth
                      options={zipcodes}
                      getOptionLabel={(option) => option.zipcode}
                      value={formData.zipcode !== '' ? formData.zipcode : null}
                      onChange={(event, newValue) => handleChange('zipcode', newValue)}
                      renderInput={(params) => <TextField {...params} placeholder="Zipcode" />}
                      error={formErrors.zipcode}
                      helperText={formErrors.zipcode}
                      id="zipcode"
                    />

                    {formErrors.zipcode && (
                      <Typography color="error" variant="caption">
                        {formErrors.zipcode}
                      </Typography>
                    )}
                  </FormControl> :
                  <FormControl variant="standard" fullWidth>
                    <FormLabel>Zipcode</FormLabel>
                    <TextField
                      placeholder="Zipcode"
                      size='small'
                      value={formData.zipcode}
                      onChange={(event) => handleChange('zipcode', event.target.value)}
                      error={Boolean(formErrors.zipcode)}
                      helperText={formErrors.zipcode}
                    />
                    {
                      console.log("zip",formData?.zipcode)
                    }
                    {formErrors.zipcode && (
                      <Typography color="error" variant="caption">
                        {formErrors.zipcode}
                      </Typography>
                    )}
                  </FormControl>

              }

            </Grid>
            <Grid item xs={12}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Description</FormLabel>
                <ReactQuill
                  theme="snow"
                  onChange={(e) => {
                    onTextEditorchanged(e);
                  }}
                  name="description"
                  value={formData.description}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                <Box sx={{ display: 'flex', gap: '10px' }}>
                  <Button variant="outlined" size="small" onClick={cancelHandler}>
                    Cancel
                  </Button>
                  <Button variant="contained" size="small" onClick={submitHandler}>
                    Next
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={1.5} />
    </Grid>
  );
};

export default AddDetailsForm;
